import React, { useRef, useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { defaultAreaId, reportingYear } from "../../../constants";
import AreaChooser from "../../choosers/AreaChooser";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import MethodMixOfUseVsCostChart from "./MethodMixOfUseVsCostChart";
import { formatValue } from "../../../utilities";

const MethodMixOfUseVsCostChartWidget = props => {
  const [areaId, setAreaId] = useState(defaultAreaId);

  const ref = useRef();

  return (
    <DataViewerFrame
      dataViewerId="method_mix_of_use_vs_cost_chart"
      reference="Figure 4.1"
      title={`Method Mix of Use versus Cost, ${reportingYear}`}
      subtitle="Segmented by Sector"
      contentWidth={300}
      filters={[
        <AreaChooser
          id="figure-4-1"
          label="Select Country or Country Group"
          areas={props.database.areas}
          includeCountries={true}
          selectedKey={areaId}
          onChange={areaId => {
            setAreaId(areaId);

            props.onChange({
              widget: "theme4.methodMixOfUseVsCostChart",
              payload: {
                areaId
              }
            });
          }}
        />
      ]}
      chartRef={ref}
      chartSettings={{
        area: props.database.areas[areaId].area
      }}
    >
      <MethodMixOfUseVsCostChart
        ref={ref}
        data={props.data}
        tooltipFormatter={function() {
          return `${this.series.name} Share of ${
            this.key
          } Mix: <strong>${formatValue(
            Math.abs(this.percentage) / 100,
            true
          )}</strong>`;
        }}
      />
    </DataViewerFrame>
  );
};

MethodMixOfUseVsCostChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default MethodMixOfUseVsCostChartWidget;
